import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ModalPopUp(props) {
    const { open, setOpen, headerText, handleRouteReiceveFee } = props
//   const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        
      >
        <DialogTitle id="alert-dialog-title">
          {headerText}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Print the Opd details
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleRouteReiceveFee}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}